// src/utils/constant.ts
var emptyPlaceholder = "--";

export {
  emptyPlaceholder
};
